import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在｜看料88",
    description: "你访问的页面不存在或已经迁移，可以返回看料88 首页或浏览猛料合集继续查看最新话题。",
    path: location.pathname,
    robots: "noindex,follow",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-24">
        <div className="w-full max-w-lg text-center">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
            <i className="ri-compass-3-line text-3xl" />
          </span>
          <p className="mt-6 font-heading text-6xl font-black leading-none text-background-200 md:text-8xl">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这个页面不在了
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            链接可能已经失效，或者内容被合并到了新的合集里。别担心，最新的话题还在持续更新。
          </p>
          <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/materials"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-400"
            >
              浏览猛料合集
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}